import { FINANCIALDATA, NONFINANCIALDATA } from "../../constants";

export const deleteRiskFactor = (riskFactorData, id) => {
    const tempRiskFactor = riskFactorData.slice();
    tempRiskFactor.forEach((item, index, element) => {
        if (id === item.id) {
            tempRiskFactor.splice(index, 1);
        }
    })
    return tempRiskFactor;
}

export const caseScorecardEditOverriddingRisk = (searchResult) => {
    const overriddingRisk = {
        id: searchResult.id,
        name: searchResult.value,
        score: searchResult.score
    }
    return overriddingRisk
}

export const updatedScore = (caseScorecardData, financialData, type) => {
    if (type === FINANCIALDATA) {
        caseScorecardData.financialData = financialData
    } else {
        caseScorecardData.nonFinancialData = financialData
    }

    return caseScorecardData
}

export const overriddingSearchUpdate = (caseScorecardData, overriddingSearch) => {
    const tempCaseScorecardData = caseScorecardData;
    tempCaseScorecardData.overridingRiskFactors = overriddingSearch;
    return tempCaseScorecardData;
}
export const handleScoreChange = (value, combinedData, id, type) => {
    switch (type) {
        case FINANCIALDATA:
            return calculateScoreUpdate(value, combinedData.financialData, id)
        case NONFINANCIALDATA:
            return calculateScoreUpdate(value, combinedData.nonFinancialData, id)
        default: return []
    }
}
export const calculateScoreUpdate = (value, data, id) => {
    for (let i = 0; i < data.length; i++) {
        if (data[i].id === id) {
            /* const regex = /.*\((\d+)\)/g;
            const temValue = regex.exec(value); */
            if (value) {
                data[i].currentScore = value;
            } else {
                data[i].currentScore = null
            }
            break
        }
    }
    return data
}

export const checkDuplicatedValue = (data, searchResult) => {
    let flag = true;
    data.forEach((item, index, element) => {
        if (item.id === searchResult.id) {
            flag = false
        }
    })

    return updateAfterDuplicateCheck(data, flag, searchResult)
}
export const updateAfterDuplicateCheck = (data, flag, searchResult) => {
    let temp = [...data]
    if (flag) {
        const searchUpdatedValue = caseScorecardEditOverriddingRisk(searchResult)
        temp.push(searchUpdatedValue)
    }
    return temp
}